<template>
  <b-modal
    title="Farm Rental"
    id="request-modal"
    ref="request-modal"
    centered
    hide-footer
  >
    <div class="modal-wrap">
      <b-row>
        <b-col cols="6">
          <small>Location:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ request.location.locationname }}</h6>
        </b-col>
      </b-row>
    </div>
    <hr />
    <div class="modal-wrap">
      <b-row>
        <b-col cols="6">
          <small>Plot Size:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ request.package.plotsize }} Plot Size</h6>
        </b-col>
      </b-row>
    </div>
    <hr />
    <div class="modal-wrap">
      <b-row>
        <b-col cols="6">
          <small>Units:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ request.units }} Plot</h6>
        </b-col>
      </b-row>
    </div>
    <hr />
    <div class="modal-wrap">
      <b-row>
        <b-col cols="6">
          <small>Amount per annum:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">
            {{ formatMoney(request.units * request.package.price) }}
          </h6>
        </b-col>
      </b-row>
    </div>

    <hr />
    <div class="modal-wrap" v-if="request.status == 'approved'">
      <b-form @input="formInput">
        <b-col cols="12">
          <b-form-group label="Pay Via">
            <b-form-radio-group
              id="payment-source"
              :options="paymentOptions"
              v-model="paymentType"
              buttons
              button-variant="white"
              name="radio-btn-outline"
              class="w-100 custom-radio"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>

        <b-collapse :visible="paymentType == 'card'" id="select-card-wrapper">
          <b-col cols="12">
            <div class="form-control">{{ formatMoney(amountPaystack) }}</div>
            <!--<b-form-group
            label="Payment"
          >
            <b-form-input
              id="amount"
              type="number"
              v-model="amountPaystack"
            ></b-form-input>
          </b-form-group>-->
          </b-col>
          <b-col>
            <b-form-group style="margin-top: 20px; text-align: right">
              <b-button
                @click="openPaystack"
                variant="primary"
                :disabled="submittingPaystack || error || loading"
                >{{ submittingPaystack ? "Paying" : "Pay Now" }}
              </b-button>
            </b-form-group>
          </b-col>
        </b-collapse>
        <b-collapse :visible="paymentType == 'bank'" id="select-card-wrapper">
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <div class="wrapper bg-light dash-card p-3 mb-4">
                  <h6>
                    Payment Details
                    <b-button
                      size="sm"
                      v-b-modal.getpaymentdetails
                      variant="primary"
                      class="my-2"
                      >How to pay</b-button
                    >
                  </h6>
                  <hr />
                  <b-row>
                    <b-col cols="6">
                      <small>Account Name</small>
                    </b-col>
                    <b-col cols="6">Globarel Limited</b-col>
                  </b-row>
                  <hr />
                  <b-row>
                    <b-col cols="6">
                      <small>Account Number</small>
                    </b-col>
                    <b-col cols="6">0251451096</b-col>
                  </b-row>
                  <hr />
                  <b-row>
                    <b-col cols="6">
                      <small>Bank</small>
                    </b-col>
                    <b-col cols="6">Guarantee Trust Bank</b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Upload Payment Proof:"
              :invalid-feedback="formErrors.paymentproof"
              :state="fieldState.paymentproof"
            >
              <b-form-file
                required
                v-model="form.paymentproof"
                accept=".jpg, .jpeg, .png, .gif"
                id="paymentproof"
                ref
                :state="fieldState.paymentproof"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form-group>
          </b-col>
          <hr />
          <b-col cols="12">
            <label for="state">
              <h6>Bank</h6>
            </label>
            <b-form-select
              id="bankcode"
              v-model="form.bankcode"
              :options="nigerianBanks"
              :state="fieldState.bankcode"
              required
              class="mb-4"
            >
              <template v-slot:first>
                <option :value="null" disabled>-- Select Your Bank --</option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback :state="fieldState.bankcode">
              {{ formErrors.bankcode }}
            </b-form-invalid-feedback>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Payment Reference:"
              :invalid-feedback="formErrors.reference"
              :state="fieldState.reference"
            >
              <b-form-input
                id="reference"
                type="text"
                v-model="form.reference"
                :state="fieldState.reference"
                placeholder="e.g 100003333222"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button @click="submit" variant="primary" class="mb-4"
              >Upload</b-button
            >
          </b-col>
        </b-collapse>
      </b-form>
      <div
        class="overlay-load position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
        style="top:0;left:0;z-index:10;background-color:rgba(255,255,255,0.7)"
        v-if="submittingPaystack || submitting"
      >
        <b-spinner label="Small Spinner"></b-spinner>
      </div>
      <paystack
        :amount="amountPaystack * 100"
        :email="userObj.email"
        :paystackkey="paystackKey"
        :callback="paystackCallback"
        :close="paystackClose"
        reference
        :embed="false"
      ></paystack>
      <b-modal
        centered
        title="Payment Bank Details"
        id="getpaymentdetails"
        ref="getpaymentdetails"
        ok-only
      >
        <div class="modal-wrap">
          <p class="mb-4">
            To make payment via bank deposit or transfer. You can make a deposit
            to the below stated bank account via bank/mobile banking transfer or
            bank deposit. Upload your payment evidence which could be a picture
            of stamped deposit slip or screenshot of the mobile transfer. Obtain
            your reference number from your bank
          </p>
          <b-row>
            <b-col cols="6">Account Name</b-col>
            <b-col cols="6">Globarel Limited</b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="6">Account Number</b-col>
            <b-col cols="6">1020259225</b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="6">Bank</b-col>
            <b-col cols="6">United Bank for Africa</b-col>
          </b-row>
          <hr />
        </div>
      </b-modal>

      <div
        class="wrapper loading-wrapper position-absolute w-100 h-100 top-0 left-0 d-flex align-items-center justify-content-center"
        style="background-color:rgba(255,255,255,0.4);z-index:10"
        v-if="submitting"
      >
        <b-spinner variant="target-save" label="Spinning"></b-spinner>
      </div>
    </div>
  </b-modal>
</template>

<script>
import paystack from "vue-paystack";
import { mapState } from "vuex";
import { TransactionService } from "@/services";
import { validateRequired, checkFormErrors } from "@/utils/validators";
import nigerianBanks from "@/utils/nigerianBanks";
import { formatMoney } from "@/utils/helpers";

export default {
  props: {
    request: null
  },
  mounted() {
    this.invPackage = this.request.package;

    this.form.packageid = this.invPackage.id;

    this.amountPaystack = (this.request.units * this.invPackage.price).toFixed(
      2
    );
  },
  data() {
    return {
      form: {
        reference: null,
        paymentproof: null,
        bankcode: null,
        addcard: 0
      },
      invPackage: {},
      packages: {},
      packagesROI: {},
      formErrors: {},
      paymentproof: null,
      paystackKey: process.env.VUE_APP_PAYSTACK_KEY,
      paymentType: null,
      paymentOptions: [
        { text: "Card", value: "card" },
        { text: "Bank Transfer/ Deposit", value: "bank" }
      ],
      nigerianBanks: nigerianBanks,
      amountPaystack: 0,
      error: false,
      submitting: false,
      submittingPaystack: false,
      loading: false,
      errorLoading: false,
      progressUpload: 0,
      firebaseUploaded: null
    };
  },
  components: {
    paystack
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },

  methods: {
    formatMoney,
    openPaystack(event) {
      event.preventDefault();
      if (!this.form.packageid) {
        this.formErrors = { packageid: "Please select a package" };
        this.error = true;
        return;
      }
      const btn = document.querySelector(".payButton");
      btn.click();
    },
    async paystackCallback(response) {
      const { reference } = response;

      this.submittingPaystack = true;
      try {
        const { message } = await TransactionService.verify(
          reference,
          this.form.packageid,
          1,
          this.request.id,
          this.form.addcard
        );

        this.$store.dispatch("toast", {
          message
        });

        this.$bvModal.hide("request-modal");

        setTimeout(() => {
          location.reload();
        }, 1000 * 1.5);
      } catch (err) {
        this.submittingPaystack = false;
      }
    },
    paystackClose() {},

    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        // this.processUpload();
        const { message } = await TransactionService.manualPayment({
          packageid: this.form.packageid,
          reference: this.form.reference,
          paymentproof: this.form.paymentproof,
          bankcode: this.form.bankcode,
          isfarmpackage: 1
        });

        this.$store.dispatch("toast", {
          message
        });

        this.$bvModal.hide("request-modal");
      } catch (err) {
        this.error = true;
        this.formErrors = err;
      } finally {
        this.submitting = false;
      }
    },
    validateForm() {
      const { reference, packageid, paymentproof, bankcode } = this.form;
      let { errors, valid } = validateRequired({
        reference,
        packageid,
        paymentproof,
        bankcode
      });

      if (
        !errors.paymentproof &&
        paymentproof &&
        !["image/jpeg", "image/jpg", "image/png"].includes(
          this.form.paymentproof.type
        )
      ) {
        errors.paymentproof = "Only picture is allowed i.e jpeg, jpg, png";
        valid = false;
      }

      if (
        !errors.paymentproof &&
        paymentproof &&
        this.form.paymentproof.size > 20 * 1024 * 1024
      ) {
        errors.paymentproof = "File size is too large (20MB Maximum)";
        valid = false;
      }

      if (this.form.packageid == 0) {
        errors.packageid = "You need to select a package";
        valid = false;
      }

      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    validateNoDecimals(e) {
      const key = e.key;

      // If is '.' key, stop it
      if (key === ".") return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") return e.preventDefault();
    },
    validateNoDecimalsOnPaste() {
      this.form.units = this.form.units.replace(/[^0-9]+/g, "");
      if (this.form.units > 0)
        this.amountPaystack = this.form.units * this.invPackage.price;
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>
